module.exports = __webpack_public_path__ + "media/img/auth/facebook-5019aa26ece82f14be97bdc6c76fcfdb.svg";